"use client";

import {
  AffordabilityIcon,
  MortgageIcon,
  RennovationIcon,
  ValutaionIcon,
} from "@/components/Icons";
import { useHashState } from "@/hooks/useHash";
import { useTranslations } from "next-intl";
import { useEffect } from "react";
import { ContentBlock } from "../Common/ContentBlock";
import { ToolCard } from "./Card";

const TOOLS = [
  {
    link: "/affordability-calculator",
    key: "houses-you-can-afford",
    icon: AffordabilityIcon,
    disabled: false,
  },
  {
    link: "/yalla-value",
    key: "instant-property-valuation",
    icon: ValutaionIcon,
    disabled: false,
  },
  {
    link: "/mortgage-calculator",
    key: "monthly-mortgage-estimate",
    icon: MortgageIcon,
    disabled: false,
  },
  {
    link: "/renovation-calculator",
    key: "renovate-with-budget",
    icon: RennovationIcon,
    disabled: false,
  },
];

export const ToolsSection = () => {
  const t = useTranslations("home.tools");

  const [hash] = useHashState();

  useEffect(() => {
    if (hash == "tools") {
      const communitiesSection = document.getElementById("tools");
      communitiesSection?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [hash]);

  return (
    <ContentBlock title={t("title")} id="tools" titleElement={"h2"}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-6">
        {TOOLS.map((tool, i) => (
          <ToolCard
            key={i}
            cta={t(`cards.${tool.key}.cta`)}
            description={t.raw(`cards.${tool.key}.description`)}
            title={t(`cards.${tool.key}.title`)}
            icon={tool.icon}
            link={tool.link}
            disabled={tool.disabled}
          />
        ))}
      </div>
    </ContentBlock>
  );
};
